import React, {useMemo} from 'react';
import {Button, Text} from '../../components';
import {useScreenSize} from '../../utils/useScreenSize';
import faith from '../../images/work/faith-in-nature.png';
import start from '../../images/work/clear-start.jpg';
import flo from '../../images/work/brand-003.png';
import dermalogica from '../../images/work/dermalogica.jpg';
import fluxies from '../../images/work/fluxies.png';
import indu from '../../images/work/indu.jpg';
import {usePageWidth} from '../../utils/usePageWidth';
import {wideMargins} from '../../constants';
import {useCarouselNavigation} from '../../utils/useCarouselNavigation';

const partnershipsList = [
  {
    brandName: 'Start Clear',
    img: start,
  },
  {
    brandName: 'Flo',
    img: flo,
  },
  {
    brandName: 'fluxies',
    img: fluxies,
  },
  {
    brandName: 'Faith in Nature',
    img: faith,
  },
  {
    brandName: 'indu',
    img: indu,
  },
  {
    brandName: 'dermalogica',
    img: dermalogica,
  },
];

export const Partnerships = ({
  title,
  subtitle,
}: {
  title: string;
  subtitle: string;
}) => {
  const screenSize = useScreenSize();
  const lastSlideIndex = partnershipsList.length;

  const pageWidth = usePageWidth();

  const setup = useMemo((): {
    mainCardSize: number;
    cardMarginCalc: number;
  } => {
    if (screenSize === 'extra-large' || screenSize === 'xx-large') {
      return {
        mainCardSize: 23.25,
        cardMarginCalc: pageWidth / 2 - 176,
      };
    } else if (screenSize === 'large') {
      return {
        mainCardSize: 23.25,
        cardMarginCalc: pageWidth / 2 - 176,
      };
    } else {
      return {
        mainCardSize: 19.25,
        cardMarginCalc: pageWidth / 2 - 144,
      };
    }
  }, [screenSize, pageWidth]);

  const {currentSlideIndex, swipeHandlers} = useCarouselNavigation({
    itemCount: lastSlideIndex,
    wrap: true,
    autoplayIntervalMs: 2200,
  });

  return (
    <div>
      <div className={`${wideMargins} text-black text-center flex flex-col`}>
        <Text as="h2" variant="Title">
          {title}
        </Text>
        <Text as="p" variant="LargeBody" className="pt-6">
          {subtitle}
        </Text>
        <div className="pt-8 pb-8 lg:pb-12 min-w-fit h-[3.5rem] mx-auto">
          <Button
            label="Contact us"
            type="primary"
            externalLinkUrl="mailto:hello@weareluna.app"
          />
        </div>
      </div>
      <div {...swipeHandlers}>
        <div className="overflow-x-hidden">
          <div
            className={`flex items-center transition ease-out duration-700 gap-5 h-[26rem] my-8`}
            style={{
              marginLeft: setup.cardMarginCalc,
              transform: `translatex(-${
                currentSlideIndex * setup.mainCardSize
              }rem)`,
            }}>
            {partnershipsList.map((p, i) => (
              <div
                key={i}
                className={`${
                  i === currentSlideIndex
                    ? 'animate-growCard h-[26rem]'
                    : 'h-[22.5rem]'
                } min-w-[18rem] lg:min-w-[22rem] w-[18rem] lg:w-[22rem]`}>
                <img
                  src={p.img}
                  alt={`An image of ${p.brandName}`}
                  className={`rounded-[2rem] object-cover object-center min-h-full max-h-full w-full `}
                  draggable={false}
                  key={i}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
